module.exports = __webpack_public_path__ + "static/img/111.f2f24ead.gif";